import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { Card } from 'primeng/card';
import { PreviewAddressComponent } from '../../../../shared/components/address/preview-address/preview-address.component';
import { Organizacja } from '../../../../shared/models/organizacja';
import { PreviewOrganizationDetailsComponent } from '../../../../shared/components/organization/preview-organization-details/preview-organization-details.component';
import { PreviewOrganizationAccountNumberComponent } from '../../../../shared/components/organization/preview-organization-account-number/preview-organization-account-number.component';
import { PreviewContact } from '../../../../shared/components/preview-contact/preview-contact';
import { Router } from '@angular/router';
import { APP_PATHS } from '../../../../core/config/app-paths';
import { MessageModule } from 'primeng/message';
import { InfoMessageComponent } from '../../../../shared/components/info-message/info-message.component';
import { PreviewOrganizationSubject } from '../../../../shared/components/organization/preview-organization-subject/preview-organization-subject';

@Component({
  selector: 'app-organization-setting-data',
  imports: [
    Card,
    PreviewAddressComponent,
    PreviewOrganizationDetailsComponent,
    PreviewOrganizationAccountNumberComponent,
    PreviewContact,
    PreviewOrganizationSubject,
    MessageModule,
    InfoMessageComponent,
  ],
  templateUrl: './organization-settings-data.component.html',
  styleUrl: './organization-settings-data.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationSettingsDataComponent {
  public organization = input<Organizacja>();
  #router = inject(Router);

  protected navigateToHomePage(): void {
    const url = `${APP_PATHS.home}`;
    this.#router.navigate([url]);
  }
}
